import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'We had a CRM, but it was not satisfactory. Evaluations were impossible, a lot of manual work. Now we have clean KPIs, a smooth workflow, and the automations are simple, clear, and they work - that is what counts in the end.',
  author: 'Thorsten Wittmann',
  role: 'Managing Director',
  company: 'TWI International',
  rating: 5
}, {
  quote: 'The simplicity for our sales team is perfect. The workflow is completely streamlined and optimized. The call volume has doubled to tripled - resulting in a 30 to 50 percent increase in revenue through the collaboration.',
  author: 'Samin Quraischi',
  role: 'Co-Founder',
  company: 'Hiit The Beat',
  rating: 5
}, {
  quote: 'I just scheduled the first setting and it is simply insane how it switches over automatically. The automation works perfectly and saves us an extreme amount of time in sales.',
  author: 'Ray Dettmann',
  role: 'Head of Sales',
  company: 'Dreamlife.now',
  rating: 5
}, {
  quote: 'Increased revenue from 30k to 80k. Turned up the ad budget to 15,000€. My team only focuses on calls - everything else runs automatically. We easily have 200 dial attempts per employee. 10 out of 10 satisfaction.',
  author: 'Thomas Bux',
  role: 'Managing Director',
  company: 'Bux Consulting',
  rating: 5
}, {
  quote: 'From Excel lists to complete order. The call volume has doubled. I was able to listen to all recordings and see who is really good. Constant growth without 14-hour days. Everything implemented very quickly.',
  author: 'Viktor Bajtinger',
  role: 'Managing Director',
  company: 'Self-Employment Coaching',
  rating: 5
}, {
  quote: 'From 28k to 92k net order volume with 2 people. 300-450 dial attempts per day instead of 100. One employee now manages what I used to need 2-3 people for. Productivity has doubled, tripled, quadrupled. Absolute game changer.',
  author: 'Mario Amadori',
  role: 'Managing Director',
  company: 'E-Commerce Coaching',
  rating: 5
}];
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" ref={ref} data-id="element-311" data-mp="1ejoejpmemo3l">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312" data-mp="1el7rp7crkj15">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-313" data-mp="19rmtpfb67p1y">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-314" data-mp="quln5q1yxgvw">
            Client Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-315" data-mp="37fqqtsbf2l1t">
            What our clients say
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-316" data-mp="3cflfdp7pyyjp">
            Over 110 companies trust our Close CRM expertise. Here are some of
            their experiences.
          </p>
          <p className="text-center text-sm text-gray-600 mb-8" data-id="element-317" data-mp="2jrh6yvxrk7db">
            TRUSTED BY 110+ ENTREPRENEURS
          </p>
        </motion.div>

        {/* Rating summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-wrap justify-center items-center gap-8 mb-12" data-id="element-318" data-mp="2srcl99mm8ihk">
          <div className="flex items-center gap-2" data-id="element-319" data-mp="1lxoltds2v2ch">
            <div className="flex" data-id="element-320" data-mp="1gxtwhenyaktj">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-321" data-mp="1gvpk08bzkdhn" data-mpi={i} />)}
            </div>
            <span className="text-white font-bold text-xl" data-id="element-322" data-mp="1quf1hzzyzvxd">5.0</span>
          </div>
          <span className="text-gray-500" data-id="element-323" data-mp="24mczpfs587er">|</span>
          <span className="text-gray-400" data-id="element-324" data-mp="24p7kj8f2ju8p">Based on 110+ reviews</span>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-325" data-mp="1zqnzda8aumhe">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="p-6 rounded-2xl bg-[#1a1a1a] border border-white/5" data-id="element-326" data-mp="29mr2ojew0r5x" data-mpi={index}>
              <div className="flex gap-1 mb-4" data-id="element-327" data-mp="2h5h1xi3zj5ri">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-328" data-mp="2m30gkj4lhkjz" data-mpi={i} />)}
              </div>
              <p className="text-gray-300 leading-relaxed mb-6" data-id="element-329" data-mp="2c8gw98b1s50x">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-330" data-mp="1y98rlzw484pc">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#0ea5e9] to-[#06b6d4] flex items-center justify-center text-white font-semibold text-sm" data-id="element-331" data-mp="236hdobkdwsvv">
                  {testimonial.author.split(' ').map(n => n[0]).join('')}
                </div>
                <div data-id="element-332" data-mp="3r401o77bz1yk">
                  <p className="text-white font-medium text-sm" data-id="element-333" data-mp="3r3qltcg02b6l">
                    {testimonial.author}
                  </p>
                  <p className="text-gray-500 text-xs" data-id="element-334" data-mp="3m5ouk48f75k1">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}